/* unplugin-vue-components disabled */import script from "./ComingSoon.vue?vue&type=script&setup=true&lang=js"
export * from "./ComingSoon.vue?vue&type=script&setup=true&lang=js"

import "./ComingSoon.vue?vue&type=style&index=0&id=13e2f7e2&scoped=true&lang=scss"

import exportComponent from "D:\\pangu_artificial_intelligence_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13e2f7e2"]])

export default __exports__